import type {State} from '@/redux/typesNew';

const v1State = (state: State) => state.v1;

export const hotelsState = (state: State) => v1State(state).hotels;
export const offersState = (state: State) => v1State(state).offers;
export const availabilityState = (state: State) => v1State(state).availability;
export const keywordDataState = (state: State) => v1State(state).keywordData;
export const offerUpsellingState = (state: State) =>
  v1State(state).offerUpselling;
export const offerAlternativeFlightsState = (state: State) =>
  v1State(state).offerAlternativeFlights;
